import React from "react";
import { AutocompleteInput, NumberInput, required, TextInput, BooleanInput } from "react-admin";
import { CountryEnum } from "src/common/enum";
import Transformer from "src/common/Transformer";
import { TeritoryEditComponent } from "./TeritoryComponent";
import { Edit, TabbedForm, FormTab } from "src/enterprise/ra-rbac";
import { Grid } from "@mui/material";
import { PhoneInput, StateInput } from "src/components/input";

export const TerritoryEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt"],
      update: {
        main: data.main !== null ? data.main.toString() : "false",
        international: data.international !== null ? data.international.toString() : "false",
        showroom: data.showroom !== null ? data.showroom.toString() : "false",
      }
    });

    return data;
  };

  return (
    <Edit
      component={TeritoryEditComponent}
      mutationMode="pessimistic"
      transform={transform}
    >
      <TabbedForm>
        <FormTab label="General" name="general">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} lg={6}>
              <TextInput source="id" disabled />
            </Grid>
            <Grid item sm={12} lg={6}>
              <TextInput source="legacy_id" label="Legacy ID"/>
            </Grid>
            <Grid item sm={12} lg={6}>
              <TextInput source="name" validate={required()} />
            </Grid>
            <Grid item sm={12} lg={6}>
              <TextInput source="email" type="email" validate={required()} />
            </Grid>
            <Grid item sm={12} lg={6}>
              <PhoneInput source="phone" label="Phone" validate={required()}/>
            </Grid>
            <Grid item sm={12} lg={3}>
              <NumberInput source="commission" />
            </Grid>
            <Grid item sm={12} lg={3}>
              <NumberInput source="sample_rating" />
            </Grid>

          </Grid>
        </FormTab>
        <FormTab label="Address" name="general">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} lg={6}>
              <TextInput source="shipping_name" validate={required()} />
            </Grid>
            <Grid item sm={12} lg={6}>
              <TextInput source="street_address" validate={required()} />
            </Grid>
            <Grid item sm={12} lg={3}>
              <TextInput source="city" validate={required()} />
            </Grid>
            <Grid item sm={12} lg={3}>
              <TextInput source="zip" validate={required()} />
            </Grid>

            <Grid item sm={12} lg={3}>
              <AutocompleteInput
                source="country"
                size="small"
                choices={CountryEnum.slice(1)}
                sx={{
                  "#state": { width: "100%" },
                }}
                emptyValue={""}
                validate={required()}
              />
            </Grid>
            <Grid item sm={12} lg={3}>
              <StateInput />
            </Grid>
          </Grid>
        </FormTab>
        <FormTab label="Showroom" name="showroom">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} lg={6}>
              <BooleanInput source="showroom"></BooleanInput>
            </Grid>
            <Grid item sm={12} lg={6}>
              <Grid container rowSpacing={1} columnSpacing={2}>
                <Grid item sm={12} lg={6}>
                  <BooleanInput source="main"></BooleanInput>
                </Grid>
                <Grid item sm={12} lg={6}>
                  <BooleanInput source="international"></BooleanInput>
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm={12} lg={6}>
              <TextInput source="title"/>
            </Grid>
            <Grid item sm={12} lg={6}>
              <TextInput source="serve"/>
            </Grid>
          </Grid>
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};

